/* tslint:disable:max-line-length */
import { DefaultMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type ExtendedMessages = {
    step: {
        personalInfo: {
            title: string,
        },
        success: {
            title: string,
            subtitle: string,
        },
        docUpload: {
            title: string,
            subtitle: string,
        },
    },
};

export const studentMessagesEN: DefaultMessages & SegmentSpecificMessages & ExtendedMessages = {
    limitExceededError: 'Verification Limit <br><br> Exceeded',
    birthDate: 'Date of birth',
    branchOfService: 'Branch of service',
    changeLanguage: 'Change language',
    country: 'Country',
    countries: {
        AD: 'Andorra',
        AE: 'United Arab Emirates',
        AF: 'Afghanistan',
        AG: 'Antigua and Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Netherlands Antilles',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'American Samoa',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbaijan',
        BA: 'Bosnia-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brazil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Canada (exclues Québec)',
        CF: 'Central African Republic',
        CG: 'Congo',
        CH: 'Switzerland',
        CI: 'Ivory Coast (Cote D\'Ivoire)',
        CK: 'Cook Islands',
        CL: 'Chile',
        CM: 'Cameroon',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cape Verde',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DJ: 'Djibouti',
        DK: 'Denmark',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        EH: 'Western Sahara',
        ER: 'Eritrea',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Islands',
        FM: 'Micronesia',
        FO: 'Faroe Islands',
        FR: 'France',
        GA: 'Gabon',
        GB: 'United Kingdom',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'French Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Greenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (French)',
        GQ: 'Equatorial Guinea',
        GR: 'Greece',
        GS: 'South Georgia & South Sandwich Islands',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard and McDonald Islands',
        HN: 'Honduras',
        HR: 'Croatia',
        HT: 'Haiti',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Iceland',
        IT: 'Italy',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KH: 'Cambodia',
        KI: 'Kiribati',
        KM: 'Comoros',
        KN: 'Saint Kitts & Nevis Anguilla',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KY: 'Cayman Islands',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Lebanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MC: 'Monaco',
        MD: 'Moldavia',
        ME: 'Montenegro',
        MG: 'Madagascar',
        MH: 'Marshall Islands',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macau',
        MP: 'Northern Mariana Islands',
        MQ: 'Martinique (French)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'New Caledonia (French)',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesia (French)',
        PG: 'Papua New Guinea',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Poland',
        PM: 'Saint Pierre and Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion (French)',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russian Federation',
        RW: 'Rwanda',
        SA: 'Saudi Arabia',
        SB: 'Solomon Islands',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Sweden',
        SG: 'Singapore',
        SH: 'Saint Helena',
        SI: 'Slovenia',
        SK: 'Slovak Republic',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        ST: 'Saint Tome (Sao Tome) and Principe',
        SV: 'El Salvador',
        SY: 'Syria',
        SZ: 'Swaziland',
        TC: 'Turks and Caicos Islands',
        TD: 'Chad',
        TF: 'French Southern Territories',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkey',
        TT: 'Trinidad and Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'USA Minor Outlying Islands',
        US: 'United States',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatican City State',
        VC: 'Saint Vincent & Grenadines',
        VE: 'Venezuela',
        VG: 'Virgin Islands (British)',
        VI: 'Virgin Islands (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis and Futuna Islands',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'South Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    dateTime: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        month: 'Month',
        day: 'Day',
        year: 'Year',
        '20_MIN': '20 minutes',
        '2_HOURS': '2 hours',
        '24_HOURS': '24 hours',
        '3_DAY': '3 days',
        A_FEW_MINUTES: 'a few minutes',
        A_FEW_HOURS: 'a few hours',
        A_FEW_DAYS: 'a few days',
    },
    dischargeDate: 'Discharge date',
    emailAddress: 'Email address',
    emailExplanation: 'Needed to send you your unique code',
    schoolName: 'University / college name',
    phoneNumber: 'Mobile Number',
    error: 'Error',
    firstName: 'First name',
    memberId: 'ID Number',
    optional: 'Optional',
    howDoesReviewWork: 'How does review work?',
    howDoesVerifyingWork: 'How does verifying work?',
    informationTransferredToUS: 'Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.',
    lastName: 'Last name',
    loading: 'Loading...',
    locales: {
        ar: 'Arabic',
        bg: 'Bulgarian',
        cz: 'Czech',
        da: 'Danish',
        de: 'German',
        el: 'Greek',
        'en-GB': 'English (UK)',
        'en-US': 'English',
        'es-ES': 'Spanish (Spain)',
        es: 'Spanish',
        fi: 'Finnish',
        'fr-CA': 'French (Canadian)',
        fr: 'French',
        hr: 'Croatian',
        hu: 'Hungarian',
        id: 'Indonesian',
        is: 'Icelandic',
        it: 'Italian',
        iw: 'Hebrew',
        ja: 'Japanese',
        ko: 'Korean',
        lt: 'Lithuanian',
        ms: 'Malay',
        nl: 'Dutch',
        no: 'Norwegian',
        pl: 'Polish',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        ro: 'Romanian',
        ru: 'Russia',
        sk: 'Slovak',
        sl: 'Slovenian',
        sr: 'Serbian',
        sv: 'Swedish',
        tr: 'Turkish',
        'zh-HK': 'Chinese (Hong Kong)',
        zh: 'Chinese (Traditional)',
    },
    militaryStatus: 'Military status',
    noOptions: 'No options',
    personalInformation: 'Personal Information',
    personalOrSchoolIsFine: 'Personal or school email is fine',
    postalCode: 'Postal code',
    poweredBy: 'Verification services powered by SheerID',
    requiredFields: 'All fields are required',
    school: 'School',
    sheeridFaqs: 'SheerID FAQs',
    studentInfoShared: 'Information entered into this web form will be used for verification purposes. The information will be shared with {companyName}. ',
    universityName: 'University name',
    verifyAndContinue: 'Verify and continue',
    verificationPurposesOnly: 'Used for verification purposes only',
    verifyMyStudentStatus: 'Verify My Student Status',
    verifyMyTeacherStatus: 'Verify My Teacher Status',
    verifyMyMembershipStatus: 'Verify My Membership Status',
    verifyMyMilitaryStatus: 'Verify My Military Status',
    verifyMyMedicalProfessionalStatus: 'Verify My Medical Professional Status',
    verifyMyEmploymentStatus: 'Verify My Employee Status',
    status: 'Status',
    VETERAN: 'Veteran',
    MILITARY_RETIREE: 'Military Retiree',
    RESERVIST: 'Reservist',
    ACTIVE_DUTY: 'Active Duty',
    MILITARY_FAMILY: 'Registered Military Dependent',
    FIREFIGHTER: 'Firefighter',
    POLICE: 'Police',
    EMT: 'EMT',
    organization: 'Organization',
    verifyMyFirstResponderStatus: 'Verify My First Responder Status',
    firstResponderInfoShared: 'Information entered here will be used for verification purposes',
    militaryInfoShared: 'Information entered here will be used for verification purposes.',
    tryAgain: 'Try again',
    errorId: {
        internalServerError: 'Internal server error',
        noProgram: 'No program found',
        noVerification: 'No verification found',
        expiredProgram: 'This link is no longer active',
        invalidProgram: 'Invalid program',
        invalidStep: 'Invalid step',
        invalidMilitaryStatus: 'Invalid military status',
        invalidFirstResponderStatus: 'Invalid first responder status',
        invalidOrganization: 'You must select an organization from the list',
        invalidFirstName: 'Invalid first name',
        invalidLastName: 'Invalid last name',
        invalidBirthDate: 'Invalid birth date',
        invalidEmail: 'Invalid email',
        invalidPhoneNumber: 'Invalid mobile number',
        invalidPostalCode: 'Invalid postal code',
        invalidAddress: 'Invalid address',
        invalidCity: 'Invalid city',
        invalidState: 'Invalid state',
        underagePerson: 'Persons under age 16 are not eligible for this offer.',
        outsideAgePerson: 'Age outside allowed range',
        futureBirthDate: 'Future birthdate',
        unsupportedDocMimeType: 'One or more files is an unsupported format',
        invalidFileSizeEmpty: 'One or more files is empty',
        invalidFileSizeMax: 'One or more files is too large (max: 10MB)',
        invalidNumberOfFiles: 'Maximum number of files exceeded (max: 5)',
        invalidDocUploadToken: 'Provided document upload token is not valid',
        verificationLimitExceeded: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed or attempted to redeem this offer.',
        apiRateLimitExceeded: 'Unable to process your request at this time, please try again later',
        docReviewLimitExceeded: 'Document review limit exceeded',
        maxMetadataValuesExceeded: 'Maximum number of metadata values exceeded',
        maxMetadataLengthExceeded: 'Maximum length of metadata value exceeded',
        unknownError: 'Unknown Error',
        invalidRequest: 'Invalid request',
        invalidApiToken: 'Provided API token was invalid or empty',
        simulatedError: 'This is a simulated error',
        notFound: 'Not found',
        unauthorizedDomain: 'Unauthorized domain',
        invalidCountry: 'Invalid country',
        invalidMemberId: 'Invalid ID Number',
    },
    step: {
        personalInfo: {
            title: 'Unlock your offer',
            subtitle: "Verify you're a student at a degree-granting college or university.",
            howDoesVerifyingWorkDetails: `
                To be eligible for this offer, you must currently be enrolled in a degree-granting,
                accredited school of higher education.
                <br><br>
                {companyName} uses SheerID, a trusted partner, to verify that you are a current student. SheerID only
                collects information that assists in verifying your eligibility.
                Additional information or documentation may be requested.`,
            tryAgain: {
                title: 'Check Your Name & Birthdate',
                subtitle: 'Your full name and birthdate must match what is on your official school records.',
            },
        },
        docUpload: {
            title: 'We need more <br><br> information',
            subtitle: 'Documents will be reviewed in a few minutes by staff at SheerID, a trusted partner.',
            docDisplay: 'Upload your government-issued document that shows:',
            uploadDocFullName: 'Your full name',
            uploadDocOrg: 'Your organization',
            uploadDocAffiliation: 'Your current affiliation with that organization',
            acceptableUploadExamples: 'Acceptable examples include:',
            uploadDocIdCard: 'ID Card',
            uploadDocPayStub: 'Pay stub dated within last 60 days',
            uploadDocOfficialDoc: 'An official letter',
            fileInstructions: 'Drag &amp; drop your files here or <span class="sid-dropzone-wrap--link">browse</span>',
            uploadDocAcceptableFormats: 'File must be .jpg .png .pdf .gif or .bmp',
            addFile: 'Add file',
            submitButtonLabel: 'Submit',
            cancelButtonLabel: 'Cancel',
        },
        pending: {
            title: 'Processing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status.',
            subtitle2: 'This process may take up to 20 minutes.',
            subtitle3: 'You will be contacted via email.',
        },
        success: {
            title: "Success! <br><br>You've been verified",
            subtitle: 'Here is your personal promo code. <br>It is unique to you and can only be used once.',
            copyCouponCode: 'Copy promo code',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for the email from verify@sheerid.com.',
            verificationOnly: `
                SheerID handles verification only.
                Now that you've been approved, please direct all questions about the
                promotion terms and/or code use to {companyName} customer service.
            `,
            redirectButtonText: 'Continue',
            redirectUrl: 'https://www.kipling-usa.com/new-products-collections/',
        },
        smsLoop: {
            titleWithNumber: "We've sent an SMS message to the mobile number ending in {number}. Enter your code here.",
            titleWithoutNumber: "We've sent an SMS to your mobile number. Please enter the code here.",
            verificationCode: 'Verification Code',
            errors: {
                codeVerification: 'Verification code could not be validated.',
                codeExpired: 'Verification code could not be validated.',
                codeResendLimit: 'Maximum number of re-tries has been reached.',
                resend: 'Error sending the SMS message',
            },
            successResend: 'SMS message re-sent successfully',
            incorrectNumber: {
                incorrectNumber1: 'Incorrect number? Click ',
                incorrectNumber2: 'here ',
                incorrectNumber3: 'to return to {company}',
            },
            resendButton: 'Re-send',
            submitButton: 'Submit',
        },
    },
};
